import apis from './apis'
import competitors from './competitors'
import permissions from './permissions'

export const Competitors = competitors
export const Apis = apis
export const Permissions = permissions



// WEBPACK FOOTER //
// ./src/constants/index.js